import { render } from "./Translation.vue?vue&type=template&id=abc5f866&scoped=true&ts=true"
import script from "./Translation.vue?vue&type=script&lang=ts"
export * from "./Translation.vue?vue&type=script&lang=ts"

import "./Translation.vue?vue&type=style&index=0&id=abc5f866&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abc5f866"]])

export default __exports__